export default "__VITE_ASSET__Dr6rfPs0__"